export default __webpack_public_path__ + "static/media/logo.732f5035.png";